import React, { ReactNode } from 'react';

import arrayMutators from 'final-form-arrays';
import { FormRenderProps } from 'react-final-form';

import { Form } from '@vk-hr-tek/app-ui/form';
import { useInject } from '@vk-hr-tek/core/ioc';
import { ValidationService } from '@vk-hr-tek/core/validation';

import { FormDto } from '../../dto';
import { initialValues } from '../../constants';
import { ContentSurveysFormValues } from '../../types';

interface ContentSurveysFormContainerProps {
  children: (
    renderProps: FormRenderProps<ContentSurveysFormValues>,
  ) => ReactNode;
  editContentSurvey: ContentSurveysFormValues | null;
}

export const ContentSurveysFormContainer = ({
  children,
  editContentSurvey,
}: ContentSurveysFormContainerProps) => {
  const validator = useInject(ValidationService);

  return (
    <Form<ContentSurveysFormValues>
      keepDirtyOnReinitialize
      onSubmit={() => {}}
      mutators={{ ...arrayMutators }}
      initialValues={editContentSurvey ?? initialValues}
      validate={(values) => validator.validate(values, FormDto)}
      render={(renderProps) => children(renderProps)}
    />
  );
};
